var site = site || {};
var generic = generic || {};
// eslint-disable-next-line no-use-before-define
window.pwr =
  window.pwr ||
  function () {
    (pwr.q = pwr.q || []).push(arguments);
  };

(function ($) {
  Drupal.behaviors.writeReview = {
    renderForm: function (args) {
      var args = args || {};
      var self = this;
      var context = args.context;
      var user = args.user;
      var $writeReviewContainer = $('#power_review_container', context);
      // AV CA - Motion point FR integration.
      var prLocaleMerchantId = [];
      var prMerchantId = '';
      var prLocale =
        document.location.hostname.search('fr.aveda.ca') !== -1
          ? Drupal.settings.power_reviews.locale_fr
          : Drupal.settings.power_reviews.locale;

      if (
        typeof pwr != 'undefined' &&
        typeof Drupal.settings.power_reviews != 'undefined' &&
        typeof generic != 'undefined' &&
        typeof generic.env != 'undefined' &&
        typeof generic.env.query != 'undefined' &&
        typeof context != 'undefined'
      ) {
        var product_id = $('.js-product', context).data('product-id');
        var productName;

        if (
          generic.env.query('pr_page_id') != null &&
          generic.env.query('pr_page_id') != 'aveda-services'
        ) {
          var product_id = 'PROD' + generic.env.query('pr_page_id');
          var params = [
            {
              products: [product_id],
              query_key: 'product-quickview'
            }
          ];

          generic.jsonrpc.fetch({
            method: 'prodcat.querykey',
            params: params,
            onSuccess: function (t) {
              var productDetails = t.getValue();
              var productImageSrc;

              if (Drupal.settings.common.show_subline) {
                productName = productDetails.products[0].SUB_LINE;
              } else {
                productName = productDetails.products[0].PROD_RGN_NAME;
              }

              if (productDetails?.products?.[0]?.IMAGE_MEDIUM) {
                productImageSrc = productDetails?.products?.[0]?.IMAGE_MEDIUM;
              } else if (productDetails?.products?.[0].skus.length === 1) {
                productImageSrc = productDetails?.products?.[0]?.skus?.[0].LARGE_IMAGE?.[0];
              } else {
                productImageSrc = productDetails?.products?.[0]?.LARGE_IMAGE?.[0];
              }
              var productImageUrl = productDetails.products[0].url;

              $('.js-product-image', $writeReviewContainer).attr('src', productImageSrc);
              $('.js-product-image', $writeReviewContainer).attr('alt', productName);
              $('.js-product-image-link', $writeReviewContainer).attr('href', productImageUrl);
              $('.js-product-name', $writeReviewContainer).html(productName);
            },
            onFailure: function (t) {
              var errorObjectsArray = t.getMessages();

              console.log(errorObjectsArray);
            }
          });
        } else {
          $('#power_review_container').addClass('js-service-page');
        }
        var product = prodcat.data.getProduct(product_id);
        var page_id = generic.env.query('pr_page_id');
        var page_id_variant = generic.env.query('pr_page_id_variant');

        // Locale configuration for Hub and Multi sites
        if (typeof Drupal.settings.power_reviews.merchant_ids != 'undefined') {
          prLocaleMerchantId = self.get_power_reviews_configuration();
          prLocale =
            document.location.hostname.search('fr.aveda.ca') !== -1
              ? Drupal.settings.power_reviews.locale_fr
              : prLocaleMerchantId[0]['locale'];
        }

        if (generic.env.query('pr_page_id') != 'aveda-services') {
          prMerchantId =
            document.location.hostname.search('fr.aveda.ca') !== -1
              ? Drupal.settings.power_reviews.merchant_id_fr
              : Drupal.settings.power_reviews.merchant_id;

          // Merchant id configuration for Hub and Multi sites
          if (typeof Drupal.settings.power_reviews.merchant_ids != 'undefined') {
            prLocaleMerchantId = self.get_power_reviews_configuration();
            prMerchantId =
              document.location.hostname.search('fr.aveda.ca') !== -1
                ? Drupal.settings.power_reviews.merchant_id_fr
                : prLocaleMerchantId[0]['merchant_id'];
          }

          var pr_args = {
            api_key: Drupal.settings.power_reviews.api_key,
            locale: prLocale,
            merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
            merchant_id: prMerchantId,
            page_id: page_id,
            components: {
              Write: 'pr-write'
            }
          };
        } else {
          prMerchantId =
            document.location.hostname.search('fr.aveda.ca') !== -1
              ? Drupal.settings.power_reviews.service_merchant_id_fr
              : Drupal.settings.power_reviews.service_merchant_id;
          var pr_args = {
            api_key: Drupal.settings.power_reviews.service_api_key,
            locale: prLocale,
            merchant_group_id: Drupal.settings.power_reviews.service_merchant_group_id,
            merchant_id: prMerchantId,
            page_id: page_id,
            page_id_variant: page_id_variant,
            components: {
              Write: 'pr-write'
            }
          };
        }

        if (typeof user != 'undefined' && typeof user.user_id != 'undefined') {
          pr_args.merchant_user_id = user.user_id;
        }

        pr_args.on_submit = function (config, data) {
          $(window).scrollTop(0);
          $('.js-war-heading', $writeReviewContainer).addClass('hidden');
          if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
            site.track.reviewWriteEnd({
              product_impression_id: product_id,
              product_impression_name: productName
            });
          }
        };
        pr_args.on_render = function (config, data) {
          var best_for_label = site.translations.product.WAR_best_for_title || 'BEST FOR';
          var $emailField = $('#pr-email_collection-input', $writeReviewContainer);
          var mailValue = $emailField[0].value;
          var inputEvent = new Event('input', { bubbles: true });
          // eslint-disable-next-line no-underscore-dangle
          var tracker = $emailField[0]._valueTracker;

          if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined' && tracker) {
            $emailField.attr('value', user.email_address);
            tracker.setValue(mailValue);
            $emailField[0].dispatchEvent(inputEvent);
          }

          $('.pr-pros-form-group', $writeReviewContainer).attr(
            'data-before-content',
            best_for_label
          );
        };

        pwr('render', pr_args);
      }
    },

    attach: function (context) {
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;
      var that = this;
      var appName = generic.env.query('appName');

      if (appName) {
        document.title =
          site.translations.product.ask_n_answer + ' | ' + Drupal.settings.common.site_name;
      }
      if (signedIn) {
        $(document).on('user.loaded', function (e, user) {
          that.renderForm({
            context: context,
            user: user
          });
        });
      } else {
        if (Drupal.settings.power_reviews.signin_required) {
          var page_id = generic.env.query('pr_page_id');
          var page_id_variant = generic.env.query('pr_page_id_variant');
          var params = new URL(document.location).searchParams;

          if (page_id != 'aveda-services') {
            var returnUrl = encodeURIComponent(
              document.location.pathname + '?' + params.toString()
            );
          } else {
            var returnUrl = encodeURIComponent(
              document.location.pathname +
                '?' +
                params.toString() +
                '&pr_page_id_variant=' +
                page_id_variant
            );
          }
          var signinUrl = '/account/signin.tmpl' + '?RETURN_URL=' + returnUrl;

          document.location.href = signinUrl;
        } else {
          that.renderForm({ context: context });
        }
      }

      if (Drupal.settings.loyalty_reviews_earning) {
        generic.jsonrpc.fetch({
          method: 'user.recordSocialAction',
          params: [
            {
              action: 'review',
              url: document.referrer
            }
          ]
        });
      }
    },

    // Get merchant id and locale for power review based on locale set on the page
    get_power_reviews_configuration: function () {
      var prConfiguration = Drupal.settings.power_reviews.merchant_ids;
      var locale =
        $.cookie('LOCALE') !== null && $.cookie('LOCALE') !== ''
          ? $.cookie('LOCALE').toLowerCase()
          : 'en_at';
      var prConf = [];
      var prLocaleMerchantIdLocal = [];

      if (prConfiguration[locale]) {
        prConf = prConfiguration[locale];

        $.each(prConf, function (localeValue, merchantId) {
          prLocaleMerchantIdLocal.push({
            locale: localeValue,
            merchant_id: merchantId
          });
        });
      }

      return prLocaleMerchantIdLocal;
    }
  };
})(jQuery);
